exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#distributorLogo img {\n    height: 40px;\n}\n\n#distributorLogo {\n    float: left;\n}\n\n#header .holder {\n    overflow: hidden;\n    width: 98%;\n    margin: 0 auto;\n    padding: 10px 0px 10px 0px;\n}\n\n#header {\n    background: #318CE7;\n}", ""]);

// exports
